import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@assets/colors';

const BPMultiplier = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49321 2.08221C7.52894 1.86781 7.42207 1.65489 7.2288 1.55543C7.03553 1.45597 6.80015 1.49277 6.64646 1.64646L2.64646 5.64646C2.52761 5.7653 2.47643 5.93591 2.51022 6.10055C2.54401 6.26519 2.65826 6.40183 2.81431 6.46425L4.94065 7.31479L4.50681 9.91781C4.47108 10.1322 4.57795 10.3451 4.77122 10.4446C4.96448 10.5441 5.19987 10.5073 5.35356 10.3536L9.35356 6.35357C9.47241 6.23472 9.52359 6.06412 9.4898 5.89948C9.45601 5.73484 9.34176 5.5982 9.1857 5.53578L7.05937 4.68524L7.49321 2.08221Z"
      fill={color}
    />
  </svg>
);

BPMultiplier.propTypes = {
  color: string,
  size: number,
};

BPMultiplier.defaultProps = {
  color: N400,
  size: 12,
};

export default BPMultiplier;
